import get from "lodash/get";

// sidebar.js

const WIDTH = {
  COLLAPSED: 60,
  EXPANDED: 300,
};

const INITIAL_STATE = {
  expanded: false,
  width: 50,
};

// action types
const SYNC_SIDEBAR = "unido-web/sidebar/SYNC_SIDEBAR";

// reducer
const sidebarReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SYNC_SIDEBAR:
      return {
        ...state,
        expanded: action.expanded,
        width: action.expanded ? WIDTH.EXPANDED : WIDTH.COLLAPSED,
      };
    default:
      return state;
  }
};
export default sidebarReducer;

// action creators
export const syncSidebar = expanded => {
  return {
    type: SYNC_SIDEBAR,
    expanded,
  };
};

// selectors
export const getSidebarState = (state, props) =>
  get(state, "ui.sidebar.expanded", false);
